import { http } from "../../core/utils/http";
import authHeader from "../../core/utils/auth.header.js";
import axios, { Axios } from "axios";
import { Create, Transfer } from "./interface/wallet.interface";
import authhHeader from "../../core/utils/authh.header";

class WalletService {
  [x: string]: any;
  constructor(private readonly request: Axios) {}

  private createAxiosInstance() {
    return axios.create({
      baseURL: import.meta.env.VITE_PLATOON_BASEURL2, // Set your custom base URL here
      headers: authhHeader(), //
    });
  }

  async getWallet(): Promise<any> {
    return await this.request
      .get("/wallet", {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getOrganisationPayroll(
    organisationId: number,
    pageSize: number,
    pageNumber: number,
  ): Promise<any> {
    return await this.request
      .get("/Transaction/get-organisation-payroll-transaction", {
        headers: authHeader(),
        params: {
          OrganisationId: organisationId,
          PageSize: pageSize,
          PageNumber: pageNumber,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getTotalRevenue(organisationId?: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    const params = organisationId ? { organisationId } : {};

    return await customRequest
      .get("/Dashboard/get-total-revenue-received", {
        headers: authHeader(),
        params,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async pendingDisbursement(organisationId?: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    const params = organisationId ? { organisationId } : {};

    return await customRequest
      .get("/Dashboard/get-total-pending-disbursement", {
        headers: authHeader(),
        params,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getTotalFundDisbursed(organisationId?: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    const params = organisationId ? { organisationId } : {};

    return await customRequest
      .get("/Dashboard/get-total-fund-disbursed", {
        headers: authHeader(),
        params,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getTotalFundReceived(organisationId?: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    const params = organisationId ? { organisationId } : {};

    return await customRequest
      .get("/Dashboard/get-total-fund-received", {
        headers: authHeader(),
        params,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getChartData(year: any, organisationId?: number): Promise<any> {
    const customRequest = axios.create({
      baseURL: import.meta.env.VITE_PLATOON_BASEURL2,
      headers: authhHeader(),
    });

    const params: any = { Year: year };
    if (organisationId) {
      params.OrganisationId = organisationId;
    }

    return await customRequest
      .get("/Transaction/history", {
        params,
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getChartYears(): Promise<any> {
    // Return current year and previous years as options
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= currentYear - 5; i--) {
      years.push(i);
    }
    return { data: { history: years } };
  }

  async getLastTransaction(): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .get("/Transaction/last", {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getTotalWalletBalance(): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .get("/Wallet/total-balance", {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getDashboardFundsSummary(params?: {
    startDate?: string;
    endDate?: string;
    organisationId?: number;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();
    const queryParams: any = {};
    if (params?.startDate) queryParams.startDate = params.startDate;
    if (params?.endDate) queryParams.endDate = params.endDate;
    if (params?.organisationId)
      queryParams.organisationId = params.organisationId;

    return await customRequest
      .get("/Dashboard/funds/summary", {
        headers: authhHeader(),
        params: queryParams,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async transfer(data: Transfer): Promise<any> {
    return await this.request
      .post(
        "/wallet/transfer",
        { ...data },
        {
          headers: authHeader(),
        },
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getBanks(): Promise<any> {
    return await this.request
      .get("/services/banks", {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getWalletHistory(): Promise<any> {
    return await this.request
      .get("/wallet/transactions", {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async createWallet(): Promise<any> {
    return await this.request
      .post(
        "/wallet",
        {},
        {
          headers: authHeader(),
        },
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
}

export default new WalletService(http);
